let wintop = 0;

export const defaultSettings = {
    onShow: (modal: any) => {
        wintop = window.scrollY;
        document.body.classList.add('modal-show');
        document.body.style.top = `${-wintop}px`;
        document.body.style.setProperty('--wintop', `${wintop}px`);
        window.dispatchEvent(new Event('resize'));
    },
    onClose: (modal: any) => {
        document.body.classList.remove('modal-show');
        window.scroll(0, wintop);
        document.body.style.removeProperty('top');
        document.body.style.removeProperty('--wintop');
        const modalIframeBlock = modal.querySelector('.modal__iframe');
        if (
            typeof modalIframeBlock !== 'undefined' &&
            modalIframeBlock !== null
        ) {
            modalIframeBlock.removeAttribute('src');
        }
        const modalContainer = document.querySelectorAll(
            '.modal__container[style]'
        );
        modalContainer.forEach((item, index) => {
            item.style.removeProperty('--modal-scroll-top');
        });
    },
    awaitCloseAnimation: true,
    disableFocus: true,
    disableScroll: false,
};
